<template>
    <div v-if="show" class="premium-banner">
        <v-icon icon="mdi-crown" size="18" class="mr-2" />
        <span class="premium-banner-text">{{ label }}</span>
        <v-chip size="x-small" variant="flat" color="#5c4003" text-color="white" class="ml-2">{{ chipText }}</v-chip>
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    show: boolean
    label: string
    chipText: string
}>()
</script>

<style scoped>
.premium-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    margin-bottom: 16px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f5c842, #f9dc5c, #f5c842);
    color: #5c4003;
    font-weight: 600;
    font-size: 0.85rem;
    box-shadow: 0 2px 8px rgba(212, 160, 23, 0.25);
}

.premium-banner-text {
    letter-spacing: 0.5px;
    text-transform: uppercase;
}
</style>
